import React from 'react';
import { PageDecorator } from 'src/app/decorators/PageDecorator';
import { ServicesList } from 'src/features/ServicesList';
import { Welcome } from 'src/features/Welcome';
import s from './MainPage.module.scss';

export const MainPage: React.FC = () => {
	// * Render
	return (
		<PageDecorator>
			<div className={s.content}>
				<Welcome />
				<ServicesList />
			</div>
		</PageDecorator>
	);
};
